<template>
    <div>
        <div class="container">
            <div class="titleBar">
                <span class="mgl20">{{$t('CreatePage.editDevice')}}</span>                        
                <el-button class="rightButton" @click="goBack">{{$t('CreatePage.backButton')}}</el-button>
            </div>           
                       
            <el-form class="form-box" :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="80px">
                <div class="formTitle">
                    <span>{{$t('CreatePage.baseInfo')}}</span>                        
                </div>                     
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.company')" prop="company">
                            <!-- <el-select v-model="ruleForm.nickname" class="formWidth" :placeholder="$t('Message.select')" @change="((key)=>{changeCompany(key)})" disabled>
                                <el-option v-for="item in companySelect" :key="item.sssid" :label="item.nickname" :value="item.sssid"></el-option>
                            </el-select>                              -->
                            <el-input v-model="ruleForm.belong2usernames" class="formWidth" disabled></el-input>
                        </el-form-item>                          
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.group')" prop="group">
                            <!-- <el-select v-model="ruleForm.trackergroupname" class="formWidth" :placeholder="$t('Message.select')" disabled>
                                <el-option v-for="item in groupSelect" :key="item.sssid" :label="item.trackergroupname" :value="item.sssid"></el-option>
                            </el-select>                               -->
                            <el-input v-model="ruleForm.belong2trackergroups" class="formWidth" disabled></el-input>
                        </el-form-item>  
                    </el-col>    
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.deviceSeries')" prop="seriestype">
                            <el-select v-model="ruleForm.seriestype" class="formWidth" :placeholder="$t('Message.select')" @change="((key)=>{changeSeries(key)})">
                                <el-option v-for="item in seriesSelect" :key="item.seriesid" :label="item.seriesname" :value="item.seriesid"></el-option>
                            </el-select>                              
                        </el-form-item>  
                    </el-col>                       
                </el-row>

                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.mode')" prop="modeltype">
                            <el-select v-model="ruleForm.modeltype" class="formWidth" :placeholder="$t('Message.select')">
                                <el-option v-for="item in modeSelect" :key="item.modelid" :label="item.modelname" :value="item.modelid"></el-option>
                            </el-select>                              
                        </el-form-item>  
                    </el-col>                       
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.deviceName')" prop="trackername">
                            <el-input v-model="ruleForm.trackername" class="formWidth"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.imei')" prop="imei">
                            <el-input v-model="ruleForm.imei" class="formWidth" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.sn')" prop="sn">        
                            <el-input v-model="ruleForm.sn" class="formWidth"></el-input>
                        </el-form-item>  
                    </el-col>                        
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.firmwareVer')" prop="firmware">
                            <el-input v-model="ruleForm.firmware" class="formWidth"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.configFile')" prop="optionfile">
                            <el-input v-model="ruleForm.optionfile" class="formWidth"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- 预留 -->
                <!-- <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.securityFile')" prop="securityFile">
                            <el-input v-model="ruleForm.securityFile" class="formWidth"></el-input>                            
                        </el-form-item>  
                    </el-col>                        
                </el-row>                 -->
                <el-form-item class="buttonCenter">
                    <el-button type="primary" @click="onSubmit('ruleForm')">{{$t('Button.submit')}}</el-button>
                    <el-button @click="goBack">{{$t('Button.back')}}</el-button>
                </el-form-item>                    
            </el-form>
                

            <el-form v-if="fotaForm.connectionstatus != null" class="form-box" :model="fotaForm" :rules="fotaRules" ref="fotaForm" :label-position="labelPosition" label-width="80px">
                <!-- 连接参数 -->
                <div class="formTitle">
                    <span>{{$t('CreatePage.paramSetting')}}</span>                        
                </div>                     
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.ip')" prop="fotaip">
                            <el-input v-model="fotaForm.fotaip" class="formWidth"></el-input>
                        </el-form-item>                         
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.port')" prop="fotaport">
                            <el-input v-model="fotaForm.fotaport" class="formWidth"></el-input>
                        </el-form-item>
                    </el-col>    
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.cntFOTAfrequency')" prop="connectionhour">
                            <el-input v-model="fotaForm.connectionhour" class="formWidth"></el-input>
                            <!-- <el-input-number v-model="fotaForm.connectionhour" :precision="1" :step="0.1" :min="0" controls-position="right" class="formWidth"></el-input-number> -->
                        </el-form-item>
                    </el-col>                                     
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="8">
                        <div class="mt30">
                            <span class="font-set mr10">{{$t('DeviceManage.cntFOTAfunciton')}}</span>
                            <el-switch v-model="fotaForm.connectionstatus"></el-switch>  
                        </div>
            
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.alarmClock')" prop="fotaclock">
                            <el-input v-model="fotaForm.fotaclock" class="formWidth"></el-input>
                        </el-form-item>
                    </el-col>      
                </el-row>

                <el-form-item class="buttonCenter">
                    <el-button type="primary" @click="sendFOTAParam('fotaForm')">{{$t('Button.submit')}}</el-button>
                    <el-button @click="goBack">{{$t('Button.back')}}</el-button>
                </el-form-item>  
            </el-form>


        </div>


    </div>
</template>

<script>
import bus from '../../common/bus';
import Tools from '../../common/Tools';
import api from '../../../api/api.js';
import apiAllSystem from '../../../api/apiAllSystem.js';

export default {
    name: 'taskCreate',
    components: { 

    },     
    data() {
        return {
            labelPosition: "top",
            pagesize: 10, //每页显示条数
            curPage: 1,   //当前页数         
            multipleSelection: [],
            ruleForm: {
                company: "",
                group: "",
                modeltype: "",
                seriestype: "",
                trackername: "",
                imei: "",
                sn: "",
                firmware: "",
                optionfile: "",
                securityFile: "",
                fotaip: "",
                fotaport: "",
                connectionhour: "",
                connectionstatus: false,
                fotaclock: "",
            },
            fotaForm: {
                fotaip: "",
                fotaport: "",
                connectionhour: "",
                connectionstatus: false,
                fotaclock: "",                
            },
            companySelect: [],
            groupSelect: [],
            modeSelect: [],
            seriesSelect: [],
            tableData: [],
            loading: false,
            autoMatch: true,
            modeDisable: true,
            groupDisable: true
        };
    },
    
    computed: {
        rules() {
            return {
                // company: [
                //     { required: true, message: this.$t('Rules.require'), trigger: 'blur'},
                // ],
                // group: [
                //     { required: true, message: this.$t('Rules.require'), trigger: 'blur'},
                // ],
                modeltype: [
                    { required: true, message: this.$t('Rules.require'), trigger: 'blur'},
                ],
                seriestype: [
                    { required: true, message: this.$t('Rules.require'), trigger: 'blur'},
                ],        
                imei: [
                    { required: true, pattern: '[^ \x22]+', message: this.$t('Rules.require'), trigger: 'blur'},
                ],  
                sn: [
                    { type: "string", pattern: /^\d{11}$/, message: this.$t('Rules.sn'), trigger: 'blur'},
                ],
                trackername: [
                    { type: "string", pattern: /^[\u4E00-\u9FA5a-zA-Z0-9]+([_-][\u4E00-\u9FA5a-zA-Z0-9]+)*$/, min: 2, max: 20, message: this.$t('Rules.name'), trigger: 'blur'},
                ],
                firmware: [
                    { type: "string", pattern: /^[(]?[a-zA-Z0-9]+([-_~.()][a-zA-Z0-9]+)*[)]?$/, message: this.$t('Rules.firmwareVer'), trigger: 'blur'},
                ],                
                optionfile: [
                    { type: "string", pattern: /^[(]?[a-zA-Z0-9]+([-_~.()][a-zA-Z0-9]+)*[)]?$/, message: this.$t('Rules.configFile'), trigger: 'blur'},
                ],                                                   
            }
        },
        fotaRules() {
            
        }
    },
    created() {
        // this.getCompany();
        this.getSeries();
        this.getData();
    },

    methods: {
        goBack() {
            this.$router.go(-1);
        },      
        getCompany() {
            let params = {
                usersssid: localStorage.getItem('sssid')
            };
            api.getUser(params)
            .then(res => {
                if(res.state){
                    this.companySelect = res.value;
                } else {
                    this.$message.error(res.value.text);
                }

            })
            .catch((error) => {
                this.$message.error(this.$t('Message.reqError'));
            });             
        },
        getGroup(key) {
            let params = {
                usersssid: key
            };
            api.getTrackerGroup(params)
            .then(res => {
                if(res.state){
                    this.groupSelect = res.value;
                } else {
                    this.$message.error(res.value.text);
                }

            })
            .catch((error) => {
                this.$message.error(this.$t('Message.reqError'));
            });              

        },          
        getSeries() {
            api.getTrackerSeries()
            .then(res => {
                if(res.state){
                    this.seriesSelect = res.value;
                } else {
                    this.$message.error(res.value.text);
                }

            })

        },                       
        getMode(key) {
            let params = {
                seriesid: key
            };
            api.getTrackerModels(params)
            .then(res => {
                if(res.state){
                    this.modeSelect = res.value;
                } else {
                    this.$message.error(res.value.text);
                }

            })

        }, 
        getData() {
            this.ruleForm = JSON.parse(this.$route.query.row);
            this.getMode(this.ruleForm.seriestype);

            this.fotaForm = JSON.parse(this.$route.query.row);
            if(this.fotaForm.connectionstatus == '1') {
                this.fotaForm.connectionstatus = true;
            } else if(this.fotaForm.connectionstatus == '0') {
                this.fotaForm.connectionstatus = false;
            }
        },
        onSubmit(formName) {     
            this.$refs[formName].validate((valid) => {
                if (valid) {     
                    let param = {
                        usersssid: localStorage.getItem('sssid')
                    };
                    
                    api.editTracker(param, this.ruleForm)
                    .then(res => {
                        if(res.state){
                            this.$message.success(this.$t('Message.success'));
                            this.$router.push({path:'/deviceManage'});
                        } else {
                            this.$message.error(res.value.text);
                        }
                        
                    })
                    .catch((error) => {
                        this.$message.error(this.$t('Message.reqError'));
                    });  
                }
            })                                                  
 
        },

        sendFOTAParam(formName) {     
            this.$refs[formName].validate((valid) => {
                if (valid) {     
                    this.$confirm(this.$t('Message.cfmSendFOTAParam'), this.$t('Message.tip'), {
                        type: 'warning'
                    })
                    .then(() => {
                        let params = {
                            usersssid: localStorage.getItem('sssid'),
                            trackersssid: this.fotaForm.sssid
                        };

                        if(this.fotaForm.connectionstatus == true) {
                            this.fotaForm.connectionstatus = 1;
                        } else if(this.fotaForm.connectionstatus == false) {
                            this.fotaForm.connectionstatus = 0;
                        }
                        
                        api.sendFOTAParam(params, this.fotaForm)
                        .then(res => {
                            if(res.state){
                                this.$message.success(res.value.text);
                                this.$router.push({path:'/deviceManage'});
                            } else {
                                this.$message.error(res.value.text);
                            }
                            
                        })
                        .catch((error) => {
                            this.$message.error(this.$t('Message.reqError'));
                        });
                    })
                    .catch(() => {});                    
                }
            })                                                  
 
        },

        changeSeries(key) {
            this.ruleForm.modeltype = "";
            this.modeSelect = [];
            this.getMode(key);
        },

        changeCompany(key) {
            this.groupDisable = false;
            this.getGroup(key);
        }

    }
};
</script>

<style scoped>

</style>